import { normalize } from './normalize';
import { on, inputs } from './utils';
// prettier-ignore
var prefectures = [
    '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県',
    '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県',
    '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府',
    '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県',
    '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県',
    '鹿児島県', '沖縄県',
];
var compositionRunning = new WeakSet();
var postalCodeCache = new WeakMap();
var phone = undefined;
if (document.querySelector('input[type=tel]')) {
    fetch('https://cdn.aisrvs.net/jp/phone.json')
        .then(function (res) { return res.json(); })
        .then(function (_a) {
        var regexs = _a.regexs;
        return (phone = regexs.map(function (re) { return new RegExp("^(?:".concat(re, ")$")); }));
    })
        .catch(console.error);
}
function setValid(elem) {
    elem.classList.remove('is-invalid');
    elem.setCustomValidity('');
}
function setInvalid(elem, mesg) {
    elem.classList.add('is-invalid');
    if (mesg != null)
        elem.setCustomValidity(mesg);
}
document.body.addEventListener('compositionstart', function (ev) {
    compositionRunning.add(ev.target);
});
document.body.addEventListener('compositionend', function (ev) {
    compositionRunning.delete(ev.target);
});
on(['input', 'compositionend'], 'input:not([type=radio],[type=checkbox],[type=file]),textarea', function (ev) {
    if (!compositionRunning.has(ev.target))
        checkElem(ev.currentTarget);
});
on('change', 'input[type=radio],input[type=checkbox],select', function (ev) {
    return checkElem(ev.currentTarget);
});
function checkElem(elem) {
    if (elem.value !== '') {
        var value = normalize(elem.value, elem);
        if (value)
            elem.value = value;
        if (elem.type === 'tel') {
            checkTel(elem);
        }
        else if (elem.getAttribute('autocomplete') === 'postal-code') {
            checkPostalCode(elem);
        }
        else {
            checkText(elem);
        }
    }
    else {
        setValid(elem);
    }
    elem.classList.add('is-modified');
    if (elem.type === 'checkbox' || elem.type === 'radio') {
        inputs(elem).forEach(function (radio) { return radio.classList.add('is-modified'); });
    }
}
function checkTel(elem) {
    if (phone) {
        var value = elem.value.replace(/[- ]/g, '').replace(/^\+?81/, '0');
        for (var _i = 0, phone_1 = phone; _i < phone_1.length; _i++) {
            var re = phone_1[_i];
            var match = re.exec(value);
            if (match) {
                var newValue = match.slice(1).join('-');
                if (value !== newValue)
                    elem.value = newValue;
                setValid(elem);
                return;
            }
        }
        setInvalid(elem, '正しい電話番号を入力してください。');
    }
}
function checkPostalCode(elem) {
    var value = elem.value.replace(/[- ]/g, '');
    var code = value.slice(0, 3);
    var cache;
    if (value.length >= 3) {
        cache = postalCodeCache.get(elem);
        if ((cache === null || cache === void 0 ? void 0 : cache.code) !== code) {
            var promise = fetch("https://cdn.aisrvs.net/jp/postal/".concat(code, ".json"))
                .then(function (res) { return res.ok && res.json(); })
                .catch(console.error);
            cache = { code: code, promise: promise };
            postalCodeCache.set(elem, cache);
        }
    }
    if (value.length === 7) {
        cache.promise.then(function (postals) {
            if (!postals)
                return;
            var postal = postals[value];
            if (postal) {
                var form = elem.closest('form');
                elem.value = "".concat(code, "-").concat(value.slice(3));
                var fills = {
                    level1: prefectures[postal[0] - 1],
                    level2: postal[1],
                    line1: postal[2],
                    line2: postal[3],
                };
                var elems = {};
                for (var _i = 0, _a = Object.keys(fills); _i < _a.length; _i++) {
                    var key = _a[_i];
                    var input = form.querySelector("[autocomplete~=\"address-".concat(key, "\"]"));
                    if (input) {
                        input.value = '';
                        elems[key] = input;
                    }
                }
                var focusee = void 0;
                for (var _b = 0, _c = Object.entries(fills); _b < _c.length; _b++) {
                    var _d = _c[_b], key = _d[0], value_1 = _d[1];
                    if (value_1) {
                        elems[key].value += normalize(value_1, { z2h: true });
                        focusee = elems[key];
                    }
                }
                focusee === null || focusee === void 0 ? void 0 : focusee.focus();
            }
        });
    }
}
function validateConfirmation(elem) {
    if (elem.id.endsWith('_confirmation')) {
        var elem2 = document.getElementById(elem.id.replace(/_confirmation$/, ''));
        if (elem.value !== elem2.value) {
            console.log("validateConfirmation(".concat(elem.id, "): \"").concat(elem.value, "\" != \"").concat(elem2.value, "\""));
            return '確認の入力が一致しません。';
        }
    }
}
function validatePattern(elem) {
    var pattern = elem.dataset.pattern || ('pattern' in elem && elem.pattern);
    if (pattern && !new RegExp("^(?:".concat(pattern, ")$")).test(elem.value)) {
        console.log("validatePattern(".concat(elem.id, "): \"").concat(elem.value, "\" !~ /").concat(pattern, "/"));
        return '正しい形式で入力してください。';
    }
}
function validateMin(elem) {
    var min = elem.dataset.min || ('min' in elem && elem.min);
    if (min) {
        var value = parseFloat(elem.value);
        if (Number.isNaN(value) || value < parseFloat(min)) {
            console.log("validateMin(".concat(elem.id, "): \"").concat(elem.value, "\" < ").concat(min));
            return "".concat(min, "\u4EE5\u4E0A\u306E\u5024\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
        }
    }
}
function validateMax(elem) {
    var max = elem.dataset.max || ('max' in elem && elem.max);
    if (max) {
        var value = parseFloat(elem.value);
        if (Number.isNaN(value) || value > parseFloat(max)) {
            console.log("validateMax(".concat(elem.id, "): \"").concat(elem.value, "\" > ").concat(max));
            return "".concat(max, "\u4EE5\u4E0B\u306E\u5024\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
        }
    }
}
function checkText(elem) {
    var mesg = validateConfirmation(elem) || validatePattern(elem) || validateMin(elem) || validateMax(elem);
    if (mesg) {
        setInvalid(elem, elem.dataset.validationMessage || mesg);
    }
    else {
        setValid(elem);
    }
}
